import { Flex, HStack } from '@chakra-ui/react';
import { ProductFeatures } from '@client/graphql/__generated__/types';
import { useMemo } from 'react';
import { useIsMobile } from '~/common/hooks/useIsMobile';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { SimpleHeader } from '../../components/Layouts/SimpleHeader';
import { MapSearch } from '../../components/MapSearch/MapSearch';
import { NotSupportedMarket } from '../../components/ProductFeatures/NotSupportedMarket';
import { MainLayout } from '../MainLayout';

export const MapSearchPageContent = () => {
  const { isAuthenticated, isFeatureSupported } = useAppContext();

  const screenHeight = '100dvh';

  if (!isFeatureSupported(ProductFeatures.LISTING_OFFER_DATA)) {
    return <NotSupportedMarket />;
  }

  return (
    <>
      <HStack
        height={screenHeight}
        maxHeight={screenHeight}
        spacing={0}
        width="100%"
      >
        <MapSearch showUnauthenticatedHeader={!isAuthenticated} />
      </HStack>
    </>
  );
};

export const MapSearchPage = () => {
  const { isAuthenticated } = useAppContext();
  const isMobile = useIsMobile(true);

  const component = useMemo(() => {
    if (isAuthenticated) {
      return (
        <MainLayout tabletIsMobile={true} transparentMobileHeader={true}>
          <MapSearchPageContent />
        </MainLayout>
      );
    } else if (isMobile) {
      return (
        <>
          <Flex
            backdropFilter="blur(2px)"
            background="linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.25) 100%)"
            position="absolute"
            px={4}
            top={0}
            width="100%"
            zIndex="5"
          >
            <SimpleHeader />
          </Flex>

          <MapSearchPageContent />
        </>
      );
    }
  }, [isAuthenticated, isMobile]);

  return component;
};
